var _desc, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 14 14",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-edit-3",
    id: "Edit-3--Streamline-Feather",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Edit 3 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.500000000000001 10.833333333333336h4.875000000000001",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.937500000000002 1.8958333333333335a1.148875 1.148875 0 0 1 1.6250000000000002 1.6250000000000002L3.791666666666667 10.291666666666668l-2.166666666666667 0.5416666666666667 0.5416666666666667 -2.166666666666667L8.937500000000002 1.8958333333333335z",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/renameIcon.d9c42e1dbbd7f8553f45f6303288da00.svg";
export { ForwardRef as ReactComponent };